import { render, staticRenderFns } from "./SelectHoriz.vue?vue&type=template&id=f045a386&lang=true&"
import script from "./SelectHoriz.vue?vue&type=script&lang=js&"
export * from "./SelectHoriz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports